export const feedbackDetail = {
	selector: {
		status: '.js-feedback-detail-status',
		statePin: '.js-status-change',
		stateCheckbox: '.js-status-hidden-checkbox',
	},
}
